<template>
    <svg aria-hidden="true" focusable="false" width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="1" cy="1" r="1" fill="black" />
        <path d="M5 1H19" stroke="black" stroke-linecap="round" />
        <circle cx="1" cy="8" r="1" fill="black" />
        <path d="M5 8H19" stroke="black" stroke-linecap="round" />
        <circle cx="1" cy="15" r="1" fill="black" />
        <path d="M5 15H19" stroke="black" stroke-linecap="round" />
    </svg>
</template>
